<template>
  <div class="step-bar">
    <div class="step" v-bind:class="{ 'active': step1 }">
    	<div class="step-bubble">1</div>
    	Create Account
    </div>
    <div class="step" v-bind:class="{ 'active': step2 }">
    	<div class="step-bubble">2</div>
    	Pick your Plan
    </div>
    <div class="step" v-bind:class="{ 'active': step3 }">
    	<div class="step-bubble">3</div>
    	Checkout
    </div>
  </div>
</template>

<script>
export default {
  name: 'steps',
  props:['step1', 'step2', 'step3'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style>
.step-bar {
	padding:20px;
	display: flex;
	border-bottom: 1px solid #EEE;
}
.step-bar .step {
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis:30%;
	text-align: center;
	text-transform: uppercase;
	color: #999;
	font-size: 12px;
	font-weight: bold;
}
.step-bar .step .step-bubble {
	width: 24px;
	height: 24px;
	border-radius: 24px;
	margin: 0 auto 10px;
	line-height: 24px;
	font-size: 14px;
	color: #999;
	background-color: #EEE;
}
.step-bar .step.active {
	color: #134d93;
}
.step-bar .step.active .step-bubble {
	background-color: #ef559a;
	color: #FFF;
}
</style>
